module.exports = __webpack_public_path__ + "img/joshua-sokoya.a872e028.jpg";